import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/plant-3/(technician-screens)/technicians/"
)({
  beforeLoad: () => {
    throw redirect({ to: "/plant-3/technicians/list" });
  },
});
